import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Col, Row } from 'antd'

import ExpenseQueue, { MoveToNextExpense } from './ExpenseQueue'
import ReviewExpenseForm from './ReviewExpenseForm'
import ReviewExpenseHistory from './ReviewExpenseHistory'

export const EXPENSES_PATH = 'expenses'

type ExpensesProps = {}

const Expenses: React.FC<ExpensesProps> = () => {
  const { id } = useParams<any>()

  const [selectedExpenseId, setSelectedExpenseId] = useState<string | null>()
  const [moveToNextExpense, setMoveToNextExpense] = useState<MoveToNextExpense>(null)

  useEffect(() => {
    if (id) {
      setSelectedExpenseId(id)
    }
  }, [id])

  return (
    <>
      <Row>
        {!id && (
          <Col span={6}>
            <ExpenseQueue
              onExpenseSelected={(item) => setSelectedExpenseId(item)}
              moveToNextExpense={moveToNextExpense}
            />
          </Col>
        )}

        <Col span={id ? 24 : 18} className={'mb-16'}>
          {selectedExpenseId && (
            <ReviewExpenseForm
              expenseId={selectedExpenseId}
              refreshAfterReview={!!id}
              onExpenseReviewed={(expenseId) => {
                setMoveToNextExpense({
                  currentExpensedId: expenseId,
                  removeCurrentExpenseIdFromQueue: true,
                })
              }}
              onExpenseSkipped={(expenseId) => {
                setMoveToNextExpense({
                  currentExpensedId: expenseId,
                  removeCurrentExpenseIdFromQueue: false,
                })
              }}
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col span={!id ? 6 : 24}></Col>
        <Col span={id ? 24 : 18}>{selectedExpenseId && <ReviewExpenseHistory expenseId={selectedExpenseId} />}</Col>
      </Row>
    </>
  )
}

export default Expenses
